// extracted by mini-css-extract-plugin
export default {"root":"TherapistMapList_root__0Lfde","title":"TherapistMapList_title__erh5H","text":"TherapistMapList_text__4UZ6J","item":"TherapistMapList_item__uCOok"};